import handleClick from './handleClick';
import Button from 'components/Button';
import React from 'react';

const getButtons = (
    { closeModal, disableFooterButton, disableCloseButton, props, history, dispatch, handleNext, buttons }) => {
    const defaultCloseButton = (
        <Button type="button" onClick={() => closeModal(props)}>
            Voltar
        </Button>
    );

    if (disableFooterButton) {
        return null;
    }
    if (!buttons?.length && !disableCloseButton) {
        return defaultCloseButton;
    }

    return buttons?.map(({ action, label, onClick = action, redirect, ...buttonProps }, index) => (
        <Button
            key={index}
            type="button"
            {...buttonProps}
            onClick={(event) => handleClick({ closeModal, props, event }, { onClick, redirect, history, dispatch, handleNext })}
        >
            {label}
        </Button>
    ));
};

export default getButtons;
